module.exports = __webpack_public_path__ + "img/Xiao_Wu@2x.20425d17.png";